import { twMerge } from 'tailwind-merge';

type Primitives = string | number | boolean | null | undefined;
type ClassValue = Primitives | Record<string, Primitives> | ClassValue[];

export const cn = (...inputs: ClassValue[]): string => {
  const tokens: string[] = [];

  inputs.forEach((item) => {
    if (!item) return;

    if (typeof item === 'string') {
      return tokens.push(item);
    }

    if (typeof item === 'object') {
      if (Array.isArray(item)) {
        return tokens.push(cn(...item));
      }

      for (const key in item) {
        item[key] && tokens.push(key);
      }
    }
  });

  return twMerge(...tokens);
};
